import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-background"></div>
      <div className="footer-overlay"></div>
      <div className="footer-container">
        <div className="footer-left-column">
          <div className="footer-logo-section">
            <img src="/assets/logos/arklogo.png" alt="ARK Moving Image" className="footer-logo" />
            <h3 className="footer-company-name">ARK Moving Image</h3>
          </div>
          <p className="footer-company-desc">
            ARK Moving Image is a creative media agency specializing in ad films, corporate videos, digital commercials, and brand storytelling.
          </p>
        </div>
        <div className="footer-middle-column">
          <h3 className="footer-heading">Useful Links</h3>
          <ul className="footer-links">
            <li><a href="/" className="footer-link">Home</a></li>
            <li><a href="/about" className="footer-link">About us</a></li>
            <li><a href="/services" className="footer-link">Services</a></li>
            <li><a href="/digital-marketing" className="footer-link">Digital Marketing</a></li>
            <li><a href="/contact" className="footer-link">Contact</a></li>
          </ul>
        </div>
        <div className="footer-right-column">
          <h3 className="footer-heading">Address:</h3>
          <p className="footer-address">
            {process.env.REACT_APP_ADDRESS || ''}
          </p>
          <p className="footer-contact">
            
            <strong>Phone:</strong> {process.env.REACT_APP_PHONE_NUMBER ? `+91 ${process.env.REACT_APP_PHONE_NUMBER}` : ''}<br />
            <strong>Mobile:</strong> {process.env.REACT_APP_SECOND_NUMBER ? `+91 ${process.env.REACT_APP_SECOND_NUMBER}` : ''}<br />
            <strong>Email:</strong> {process.env.REACT_APP_EMAIL ? (
              <a
                href={`mailto:${process.env.REACT_APP_EMAIL}?subject=${encodeURIComponent('Enquiry from ARK Moving Images website')}&body=${encodeURIComponent('Hi ARK Moving Images,\n\nI would like to discuss about ...')}`}
                className="footer-email-link"
                aria-label="Send email"
              >
                {process.env.REACT_APP_EMAIL}
              </a>
            ) : ''}
          </p>
          <div className="footer-social">
            <a href={(process.env.REACT_APP_INSTAGRAM || '#')} target="_blank" rel="noreferrer" className="social-icon" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href={(process.env.REACT_APP_YOUTUBE || '#')} target="_blank" rel="noreferrer" className="social-icon" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
            <a href={process.env.REACT_APP_WHATSAPP ? `https://wa.me/91${process.env.REACT_APP_WHATSAPP}?text=${encodeURIComponent('Hi ARK Moving Images, I would like to discuss about ...')}` : '#'} target="_blank" rel="noreferrer" className="social-icon" aria-label="WhatsApp">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="copyright-container">
          <p className="copyright-text">
            © Copyright <strong>ARK Moving Image</strong>. All Rights Reserved
          </p>
    
        </div>
      </div>
    </footer>
  );
};

export default Footer;
